import React, { ReactNode } from "react"
import { unified } from "unified"
import parse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"

import {
  StyledStats,
  StyledContainer,
  StyledAccent,
  StyledValue,
  StyledText,
  StyledStatsProps,
} from "./partials"

export interface StatsProps extends StyledStatsProps {
  accent: string
  value: string
  text: string
  remove_top_spacer: string
}

export const StatsCmp: React.FC<StatsProps> = ({
  accent,
  accent_style,
  value,
  text,
  remove_top_spacer,
}) => (
  <StyledStats>
    <StyledContainer accent_style={accent_style} remove_top_spacer={remove_top_spacer} >
      {accent && (
        <StyledAccent accent_style={accent_style}>{accent}</StyledAccent>
      )}
      {value && <StyledValue accent_style={accent_style}>{value}</StyledValue>}
    </StyledContainer>

    {text && (
      <StyledText>
        {
          unified()
            .use(parse)
            .use(remarkRehype)
            .use(rehypeReact as any, {
              createElement: React.createElement,
              components: remarkReactComponents,
              Fragment: React.Fragment
            })
            .processSync(text.replace(/\n/g, "  \n")).result as ReactNode
        }
      </StyledText>
    )}
  </StyledStats>
)
